import { Modal } from "@msys/ui";
import { Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";

/**
 * "Add product list" confirmation — Close / Choose products / Confirm.
 * Pure UI: the caller decides what "add all" (`onConfirm`) and "choose
 * products" (`onChooseProducts`) do.
 */
export const AddProductListConfirmModal = ({
  title,
  itemCount,
  handleClose,
  onConfirm,
  onChooseProducts,
}: {
  title: string;
  itemCount: number;
  handleClose: () => void;
  onConfirm: () => void | Promise<void>;
  onChooseProducts: () => void | Promise<void>;
}) => {
  const { t } = useTranslate(["ProductLists", "Global"]);
  return (
    <Modal
      title={t("Add product list", { ns: "ProductLists" })}
      handleClose={handleClose}
      actionButtons={[
        {
          label: t("Close", { ns: "Global" }),
          handleClick: handleClose,
          buttonProps: { variant: "text" },
        },
        {
          label: t("Choose products", { ns: "ProductLists" }),
          handleClick: async () => {
            await onChooseProducts();
            handleClose();
          },
          buttonProps: { variant: "outlined" },
        },
        {
          label: t("Confirm", { ns: "Global" }),
          handleClick: async () => {
            await onConfirm();
            handleClose();
          },
        },
      ]}
    >
      <Typography variant="body1">
        {t(
          "Do you wish to add all {count} products from the product list “{title}”?",
          { ns: "ProductLists", count: itemCount, title }
        )}
      </Typography>
    </Modal>
  );
};
